// Module
var code = "<div class=bs-dropdown v-click-outside=onClickOutside> <div class=slot-container @click=toggle> <slot></slot> </div> <ul class=\"card list-group\" v-show=ui.visible v-bind:style=ui.containerStyle :class=listClass> <li class=dropdown-item v-for=\"item in itens\" @click=onSelect(item) v-html=getLabelByDropDownItem(item)></li> </ul> </div> ";
// Exports
module.exports = code;